import theme from "../../Components/Themes"

export const subTitle = {
    fontSize: { xs: "36px", sm: "40px", md: "48px" },
    color: theme.palette.primary.contrastText,
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
}

export const cardGrid = {
    padding: "30px",
    display: "flex",
    justifyContent: "center",
}

export const buttonGrid = {
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
    marginBottom: "200px",
}
